// import React from 'react';
import { projects } from '../data/projects';
import { Project } from '../types/project';
import ProjectTile from './ProjectTile';

const EnergyPage: React.FC = () => {
  const energyProjects = projects.filter(p => p.category === 'energy');

  return (
    <div>
      <h2>Energy Projects</h2>
      <div className="project-list">
        {energyProjects.length > 0 ? (
          energyProjects.map((project: Project) => (
            <ProjectTile key={project.id} project={project} />
          ))
        ) : (
          <p>No energy projects yet!</p>
        )}
      </div>
    </div>
  );
};

export default EnergyPage;
